export class EventSettingTranslation {
    id: number;
    locale: string;
    imprint: string;

    /**
     * constructor
     *
     * @param {EventSettingTranslation} init
     */
    public constructor(init?: EventSettingTranslation) {
        if (!!init) {
            Object.assign(this, init);
        }
    }
}
